import React from "react";
import {
  UserGroupIcon,
  ArrowTopRightOnSquareIcon,
} from "@heroicons/react/24/outline";
import { useHistory } from "react-router-dom";

export default function PatientReviewStep({ onComplete, onSkip }) {
  const history = useHistory();

  const handleGoToPatients = () => {
    history.push("/patients");
  };

  return (
    <div className="space-y-4">
      <div>
        <button
          onClick={handleGoToPatients}
          className="w-full bg-blue-600 text-white py-3 px-4 rounded-md text-sm font-medium hover:bg-blue-700 transition-colors inline-flex items-center justify-between shadow-xs"
        >
          <div className="flex items-center">
            <UserGroupIcon className="h-5 w-5 mr-3" />
            <div className="text-left">
              <div className="font-medium">Go to Patients Page</div>
              <div className="text-xs text-blue-100">
                Add any missing email addresses
              </div>
            </div>
          </div>
          <ArrowTopRightOnSquareIcon className="h-4 w-4" />
        </button>
      </div>

      <div className="bg-gray-50 rounded-lg p-3">
        <h5 className="text-gray-900 text-sm font-medium mb-3">
          Setup Steps:
        </h5>
        <ol className="text-gray-700 text-sm space-y-2">
          <li className="flex items-start">
            <span className="bg-blue-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-medium mr-3 mt-0.5 shrink-0">
              1
            </span>
            Look for patients with missing emails
          </li>
          <li className="flex items-start">
            <span className="bg-blue-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-medium mr-3 mt-0.5 shrink-0">
              2
            </span>
            Select a patient and click 'Edit Details'
          </li>
          <li className="flex items-start">
            <span className="bg-blue-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-medium mr-3 mt-0.5 shrink-0">
              3
            </span>
            Add email address and save
          </li>
          <li className="flex items-start">
            <span className="bg-blue-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-medium mr-3 mt-0.5 shrink-0">
              4
            </span>
            Repeat for other patients
          </li>
        </ol>
      </div>

      <div className="flex space-x-2">
        <button
          onClick={onSkip}
          className="flex-1 border border-gray-300 text-gray-700 py-2 px-4 rounded-md text-sm font-medium hover:bg-gray-50 transition-colors"
        >
          Skip
        </button>
        <button
          onClick={() => {
            onComplete();
            // Use setTimeout to ensure state updates are processed first
            setTimeout(() => {
              history.push("/prescriptions");
            }, 100);
          }}
          className="flex-1 bg-integria-green text-white py-2 px-4 rounded-md text-sm font-medium hover:bg-integria-green/90 transition-colors"
        >
          Done
        </button>
      </div>
    </div>
  );
}
